export default __webpack_public_path__ + "static/media/190629_192557_DSCN3480.7b179bc9.JPG";